import React from 'react';

import {
  Col,
} from "react-bootstrap";

const EducationCard = ({ data }) => {
  return (
    <Col lg="6" className='card'>
      <div className="pb-5 text-center card-body">
        <img className=" bg-white mb-3" src={data.companylogo} alt="" style={{maxWidth: "90%", height:"110px"}}/>
        <p className="lead" style={{fontWeight:"700", marginBottom:"2px"}}>
          {data.uni}          
        </p>
        <p className="lead" style={{fontStyle:"italic", fontWeight:"500", marginBottom:"2px"}}>
          {data.role}          
        </p>
        <p className="lead" style={{fontWeight:"400", fontSize: "1.05rem"}}>
          {data.date}
        </p>
        <p className="lead" style={{fontWeight:"500"}}>
            GPA: {data.gpa}
        </p>
        <h5 className='lead'>
            Coursework:
        </h5>
        {
            data.courses.map((course) => {
                return <p className='lead' style={{fontSize: "1.0rem", marginTop:"0", marginBottom:"0"}}>
                {course}
                </p>
              })
        }
        

      </div>
    </Col>
  );
}

export default EducationCard;